export function getAll() {
  return [
    {
      value: 0,
      name: "All",
      text: "全部",
    },
    {
      value: 1,
      name: "1",
      text: "1元",
    },
    {
      value: 2,
      name: "5",
      text: "5元",
    },
    {
      value: 3,
      name: "10",
      text: "10元",
    },
    {
      value: 4,
      name: "50",
      text: "50元",
    },
    {
      value: 5,
      name: "100",
      text: "100元",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
